import config from "config";
import $ from "jquery";
import Promise from "bluebird";
import ko from "knockout";
import _ from "lodash";
import Upload from "models/Upload";
import requestTracker from "services/activeRequestTracker";
import HttpError from "util/HttpError";

const uploadRoot = config.uploadService.uri;
const activeUploads = ko.observableArray([]);
let oAuthBearerToken;

function updateProgress(progressTracker, progressEvent) {
    if (progressTracker.upload) {
        progressTracker.upload.bytesUploaded(progressEvent.loaded);
        progressTracker.upload.totalBytes(progressEvent.total);
    }
}

function generateFormData(fileData, metadata) {
    const data = new FormData();

    data.append("file", fileData);
    Object.entries(metadata).forEach((entry) => {
        const [key, value] = entry;
        data.append(key, value);
    });

    return data;
}

function upload(path, fileData, metadata) {
    const url = uploadRoot + path;

    const progressTracker = {};

    const headers = {};
    if (oAuthBearerToken) {
        headers.Authorization = "bearer " + oAuthBearerToken;
    }

    let progress_xhr;
    const xhr = $.ajax({
        url: url,
        type: "POST",
        headers: headers,
        enctype: "multipart/form-data",
        xhr: function () {
            progress_xhr = new XMLHttpRequest();
            progress_xhr.upload.addEventListener(
                "progress",
                _.bind(updateProgress, null, progressTracker),
                false
            );
            return progress_xhr;
        },
        data: generateFormData(fileData, metadata),
        cache: false,
        processData: false,
        contentType: false,
    });

    const promise = Promise.cast(xhr)
        .cancellable()
        .catch(function (error) {
            if (error.name === "CancellationError") {
                xhr.abort();
                return Promise.reject(error);
            } else {
                return Promise.reject(new HttpError(error));
            }
        })
        .finally(function () {
            activeUploads.remove(progressTracker.upload);
        });

    requestTracker.addRequest(promise);
    progressTracker.upload = new Upload(promise, metadata);

    activeUploads.push(progressTracker.upload);

    return progressTracker.upload;
}

/**
 * File upload service. Handles uploading files with progress
 *
 * Usage:
 *
 * var upload = fileUploadService.post(uploadPath, fileData, fileMetadata)
 *                  .then(function(){
 *                      //upload completed
 *                  })
 *                  .catch(function() {
 *                      //upload error
 *                  });
 *
 * fileData should be of Blob or File type.
 * fileMetadata is optional
 */
export default {
    activeUploads: activeUploads,

    /**
     * Upload a file using POST
     * @param uri
     * @param data
     * @param uploadProgress Model
     */
    upload: function (path, fileData, metadata) {
        return upload(path, fileData, metadata);
    },

    setOauthBearerToken: function (bearerToken) {
        oAuthBearerToken = bearerToken;
    },
};
